export type ChunkDimensions = Readonly<{
    width: number;
    height: number;
    x: number;
    y: number;
}>;

export function chunkImage(width: number, height: number, chunkDim: number): ChunkDimensions[] {
    const ret: ChunkDimensions[] = [];

    for (let y = 0; y < height; y += chunkDim) {
        for (let x = 0; x < width; x += chunkDim) {
            const chunkWidth = Math.floor(Math.min(width - x, chunkDim));
            const chunkHeight = Math.floor(Math.min(height - y, chunkDim));
            if (chunkWidth === 0 || chunkHeight === 0) continue;

            ret.push({
                width: chunkWidth,
                height: chunkHeight,
                x,
                y,
            });
        }
    }

    return ret;
}
